@if (accordions) {
  <wl-multiple-links-list
    [accordions]="accordions"
    [collapsible]="collapsible"
  ></wl-multiple-links-list>
}
